var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalLink = function SvgExternalLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.115,
    height: 11.658,
    viewBox: "0 0 13.115 11.658",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-external-link-alt",
    "data-name": "Icon awesome-external-link-alt",
    d: "M13.115.546V3.461a.547.547,0,0,1-.933.386l-.813-.813L5.824,8.579a.546.546,0,0,1-.773,0l-.515-.515a.546.546,0,0,1,0-.773l5.545-5.545L9.268.933A.547.547,0,0,1,9.655,0h2.914A.546.546,0,0,1,13.115.546ZM9.268,6.166,8.9,6.53a.546.546,0,0,0-.16.386V10.2H1.457V2.914H7.468a.547.547,0,0,0,.386-.16l.364-.364a.546.546,0,0,0-.386-.933H1.093A1.093,1.093,0,0,0,0,2.55v8.015a1.093,1.093,0,0,0,1.093,1.093H9.108A1.093,1.093,0,0,0,10.2,10.565V6.552A.546.546,0,0,0,9.268,6.166Z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "external-link.a61ecdbb77f0175491d38ae11a778821.svg";